if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.addEventListener('click', (event) => {
          const thumbnail = event.target.closest('[data-modal-thumbnail]');
          const previousButton = event.target.closest('[data-modal-previous]');
          const nextButton = event.target.closest('[data-modal-next]');

          if (thumbnail) {
            event.preventDefault();
            this.activateMedia(thumbnail.dataset.mediaId, true);
            return;
          }

          if (previousButton || nextButton) {
            event.preventDefault();
            this.activateAdjacentMedia(nextButton ? 1 : -1);
          }
        });

        this.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.activateAdjacentMedia(-1);
          }

          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.activateAdjacentMedia(1);
          }
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.activateMedia(this.openedBy.getAttribute('data-media-id'));
      }

      activateMedia(mediaId, focusThumbnail = false) {
        if (!mediaId) return;

        const stage = this.querySelector('[data-product-modal-stage]');
        if (!stage) return;

        stage.querySelectorAll(`[data-media-id]:not([data-media-id="${mediaId}"])`).forEach((element) => {
          element.classList.remove('active');
        });

        const activeMedia = stage.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia) return;

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        this.querySelectorAll('[data-modal-thumbnail]').forEach((thumbnail) => {
          const isActive = thumbnail.dataset.mediaId === mediaId;
          if (isActive) {
            thumbnail.setAttribute('aria-current', 'true');
          } else {
            thumbnail.removeAttribute('aria-current');
          }
        });

        const activeThumbnail = this.querySelector(`[data-modal-thumbnail][data-media-id="${mediaId}"]`);
        if (activeThumbnail) {
          activeThumbnail.scrollIntoView({ block: 'nearest', inline: 'center' });
          if (focusThumbnail) activeThumbnail.focus({ preventScroll: true });
        }

        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      activateAdjacentMedia(direction) {
        const thumbnails = Array.from(this.querySelectorAll('[data-modal-thumbnail]'));
        if (thumbnails.length < 2) return;

        const activeIndex = thumbnails.findIndex((thumbnail) => thumbnail.hasAttribute('aria-current'));
        const nextIndex = activeIndex === -1 ? 0 : (activeIndex + direction + thumbnails.length) % thumbnails.length;

        this.activateMedia(thumbnails[nextIndex].dataset.mediaId);
      }
    }
  );
}
